import request from '@/utils/request';
/**
 * 获取医院列表
 *
 * @param {object} params 请求的参数
 */
export const searchHospital = params => {
  return request({
    method: 'GET',
    url: '/api/search/hospital/rank_list/',
    params,
  });
};
/**
 * 获取药品列表，根据首字母
 *
 * @param {object} params 请求的参数
 */
export const searchDrug = params => {
  return request({
    method: 'GET',
    url: '/api/search/drug/list',
    params,
  });
};
/**
 * 获取热门药品 返回大量数据 取drug_list即可
 */
export const getHotDrugList = () => {
  return request({
    method: 'GET',
    url: '/api/search/doctor/conf/',
    params: {
      conf_type_list: JSON.stringify([8]),
      from_type: '4',
    },
  });
};
/**
 * 获取地区信息
 */
export const getLocation = () => {
  return request({
    method: 'GET',
    url: '/api/locations/',
    params: {
      from_type: '1',
    },
  });
};
/**
 * 获取科室信息
 */
export const searchClinicList = () => {
  return request({
    method: 'GET',
    url: '/api/search/clinic/list/',
  });
};
/**
 * 获取筛选信息
 *
 * @param {object} params 请求来源
 */
export const searchOptionList = params => {
  return request({
    method: 'GET',
    url: '/api/search/hospital/search_option_list/',
    params,
  });
};

/**
 * 自诊自查首页获取数据
 *
 * @param {object} params 请求参数
 */
export const doctorConf = params => {
  return request({
    method: 'GET',
    url: '/api/search/doctor/conf/',
    params,
  });
};

/**
 * 大搜联想词
 *
 * @param {object} params 请求参数
 */
export const newSuggestion = params => {
  return request({
    method: 'GET',
    url: '/api/v8/search/new_suggestion/',
    params,
  });
};

/**
 * 特惠义诊列表
 *
 * @param {object} params 请求参数
 */
export const doctorList = params => {
  return request({
    method: 'GET',
    url: '/api/search/doctor/list/',
    params,
  });
};
/**
 * 疾病接口
 *
 * @param {object} params 请求参数
 */
export const searchDisease = params => {
  return request({
    method: 'GET',
    url: '/api/search/disease/',
    params,
  });
};
/**
 * 特惠义诊广告请求
 *
 * @param {object} params 请求参数
 */
export const getAdInfo = params => {
  return request({
    method: 'GET',
    url: '/ad/get_ad_info/',
    params,
  });
};

// 判断用户是否登录
export const isLogin = () => {
  return request({
    url: '/api/accounts/is_user_login/',
    method: 'GET',
  });
};

// 获取心理咨询相关信息
export const getClinicPrice = () => {
  return request({
    url: '/ask/clinic/fast_phone_order/introduction/?multi_clinic=1&is_json=1',
    method: 'GET',
  });
};

// 心理咨询提交获取列表-非微信小程序
export const createOrder = data => {
  return request({
    url: '/weixin/pay/create_order/',
    method: 'POST',
    data,
  });
};

// 心理咨询提交获取列表-微信小程序
export const createOrderWx = data => {
  return request({
    url: '/weixin/pay/',
    method: 'POST',
    data,
  });
};

/**
 * @description 获取微信小程序支付参数
 * @param {object} params 参数
 * @returns {Promise} 请求
 */
export const getPayParams = params => {
  return request({
    method: 'GET',
    url: '/cooperation/wap/get_pay_params/',
    params,
  });
};

// 获取企业心理咨询信息
export const getCompanyPsychologicalConsultDetail = params => {
  return request({
    method: 'GET',
    url: '/cooperation/wap/get_business_fast_phone_info/',
    params,
  });
};

// 判断服务是否可用
export const isServiceCanUse = params => {
  return request({
    method: 'GET',
    url: '/cooperation/wap/check_business_fast_phone_valid/',
    params,
  });
};

// 价格为0元时创建订单
export const createFreeOrder = data => {
  return request({
    method: 'POST',
    url: '/cooperation/wap/create_business_fast_phone/',
    data,
  });
};

/**
 * @description 获取订单商品对应服务顾问信息（入口在订单详情页）
 * @param {object} params 参数
 * @returns {Promise} 请求
 */
export const getConsultantInfo = params => {
  return request({
    method: 'GET',
    url: '/mall/order/consultant_info/',
    params,
  });
};

/**
 * @description 专业擅长推荐补充页获取
 * @param  {object} params 参数
 * @returns {Promise} 请求
 */
export const specialtyGoodAtGetRecommendGoodAt = params => {
  return request({
    method: 'GET',
    url: '/clinic/specialty_good_at/get_recommend_good_at/',
    params,
  });
};

/**
 * @description 专业擅长推荐补充页提交
 * @param {object} params 参数
 * @returns {Promise} 请求
 */
export const specialtyGoodAtSubmitRecommendGoodAt = params => {
  return request({
    method: 'GET',
    url: '/clinic/specialty_good_at/submit_recommend_good_at/',
    params,
  });
};

/**
 * @description 获取页面消息
 * @param {object} params 参数
 * @returns {Promise} 请求
 */
export const elevenYearPageDetail = params => {
  return request({
    method: 'GET',
    url: '/events/eleven_year/page_detail/',
    params,
  });
};

/**
 * @description 11周年送祝福
 * @param {object} data 参数
 * @returns {Promise} 请求
 */
export const elevenYearSendWishWords = data => {
  console.log(data);
  return request({
    method: 'POST',
    url: '/events/eleven_year/send_wish_words/',
    data,
  });
};

/**
 * @description 医师节获取页面消息(用户端)
 * @param {object} params 参数
 * @returns {Promise} 请求
 */
export const doctorsDayPatientPageDetail = params => {
  return request({
    method: 'GET',
    url: '/events/doctors_day/patient/h5_page_info/',
    params,
  });
};

/**
 * @description 医师节送祝福
 * @param {object} data 参数
 * @returns {Promise} 请求
 */
export const doctorsDaySendThankWords = data => {
  console.log(data);
  return request({
    method: 'POST',
    url: '/events/doctors_day/patient/send_thank_words/',
    data,
  });
};

/**
 * @description 医师节获取页面消息(医生端)
 * @param {object} params 参数
 * @returns {Promise} 请求
 */
export const doctorsDayDoctorPageDetail = params => {
  return request({
    method: 'GET',
    url: '/events/doctors_day/doctor/h5_page_info/',
    params,
  });
};
export const getAssessList = params => {
  return request({
    method: 'GET',
    url: `/api/v8/doctor/assess_rewards_list_v2/`,
    params,
  });
};
export const uploadDicomForReportRequest = data => {
  return request({
    url: '/api/crm/task/images/update/',
    method: 'POST',
    data,
  });
};
export const uploadDicomForQaRequest = data => {
  return request({
    method: 'POST',
    url: '/cooperation/wap/create_problem_content/',
    data,
  });
};
/**
 * @description: 青心计划获取活动主页详情
 * @param {*} params 参数
 */
export const getGreenHeartHome = params => {
  return request({
    method: 'GET',
    url: `/events/gold_task/green_heart/home/`,
    params,
  });
};

/**
 * @description 青心计划金币页---头部信息
 * @param {object} params 参数
 * @returns {Promise} 请求
 */
export const getQinxinTaskTopInfo = params => {
  return request({
    method: 'GET',
    url: `/events/gold_task/top_info/`,
    params,
  });
};
/**
 * @description 青心计划金币页---任务列表
 * @param {object} params 参数
 * @returns {Promise} 请求
 */
export const getQinxinTaskList = params => {
  return request({
    method: 'GET',
    url: `/events/gold_task/task_info/`,
    params,
  });
};

// 青心计划传播活动
/**
 * @description 青心计划传播活动首页信息
 * @param {object} params 参数
 * @returns {Promise} 请求
 */
export const getQinxinDisseminateHomeInfo = params => {
  return request({
    method: 'GET',
    url: `/events/share_activity/main/`,
    params,
  });
};
/**
 * @description 青心计划传播海报页信息
 * @param {object} params 参数
 * @returns {Promise} 请求
 */
export const getQinxinDisseminateBillInfo = params => {
  return request({
    method: 'GET',
    url: `/events/share_activity/get_poster_info/`,
    params,
  });
};
/**
 * @description 青心计划传播保存海报
 * @param data
 * @returns {Promise} 请求
 */
export const saveQinxinDisseminateBill = data => {
  return request({
    method: 'POST',
    url: `/events/share_activity/save_poster_info/`,
    data,
  });
};
/**
 * @description 获取url-link
 * @param params
 * @returns {Promise} 请求
 */
export const wxMiniIntroPage = params => {
  return request({
    method: 'GET',
    url: `/m/wx_mini_intro_page/`,
    params,
  });
};
/*
 * @description 发送弹幕
 * @param data
 * @returns {Promise} 请求
 */
export const sendBulletChat = (data, activiy_alias) => {
  return request({
    method: 'POST',
    url: `/events/bullet_chat/send/?activity_alias=${activiy_alias}`,
    data,
  });
};

/**
 * @description 立即抽签接口
 * @param params
 * @returns {Promise} 请求
 */
export const drawThanksGiving = params => {
  return request({
    method: 'GET',
    url: `/events/thanksgiving/draw/`,
    params,
  });
};

/**
 * @description: 12月运营活动主页
 * @param {*} params 参数
 */
export const getThanksGivingHome = params => {
  return request({
    method: 'GET',
    url: `/events/thanksgiving/home_info/`,
    params,
  });
};

/**
 * @description: 获取urlLink
 * @param {*} params 参数
 */
export const getUrlLink = params => {
  return request({
    method: 'GET',
    url: `/api/weixin/url_link/`,
    params,
  });
};

export const getLiveList = params => {
  return request({
    method: 'GET',
    url: `/api/live/speaker/activity_list/`,
    params,
  });
};

export const getAppointmentInfo = params => {
  return request({
    method: 'GET',
    url: `/wxvip/benefit/criticalillnessappointment/`,
    params,
  });
};

export const orderAppointment = data => {
  return request({
    method: 'POST',
    url: `/wxvip/benefit/criticalillnessappointment/commit/`,
    data,
  });
};

export const getPageInfo = params => {
  return request({
    method: 'get',
    url: `/wxvip/benefit/sku/`,
    params,
  });
};
export const postInquirySummary = data => {
  return request({
    method: 'POST',
    url: `/vendor/video/api/doctor/summary/submit/`,
    data,
  });
};

export const getUserArchive = params => {
  return request({
    method: 'get',
    url: `/api/patient_profile/`,
    params,
  });
};

export const createArchive = data => {
  return request({
    method: 'POST',
    url: `/ehr/patient_profile/create_or_update/`,
    data,
  });
};

export const getVideoInquiryDetail = params => {
  return request({
    method: 'GET',
    url: `/vendor/video/api/order/purchase_detail/`,
    params,
  });
};

// 中医科接口
export const getChineseMedicineDetail = params => {
  return request({
    method: 'GET',
    url: `/events/special_clinic/zhongyi/main_page/`,
    params,
  });
};

export const getChineseMedicineCoupon = params => {
  return request({
    method: 'POST',
    url: `/events/special_clinic/zhongyi/get_coupons/`,
    params,
  });
};

export const getChineseMedicinUrl = params => {
  return request({
    method: 'GET',
    url: `/events/special_clinic/zhongyi/get_doc_home_url_link/`,
    params,
  });
};

// 套餐包接口

export const getDoctorPackageDetail = params => {
  return request({
    method: 'GET',
    url: `/benefit/package/doctor/list/`,
    params,
  });
};

export const getMyPackageList = params => {
  return request({
    method: 'GET',
    url: `/benefit/package/user/list/`,
    params,
  });
};
